module.exports = "https://www.gc-pro.gnp.com.mx/ff2622a65f29c01345266ca4e726f728.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-ocupacion.svg
// module id = 974
// module chunks = 0